import React from 'react';

function ElSalvador(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123991)">
        <mask
          id="mask0_800_123991"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123991)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_123991"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123991)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#3D58DB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#3D58DB"
            />
            <path
              d="M21.9162 11.8582C21.9162 13.8157 20.1109 15.5 17.7567 15.5C15.4025 15.5 13.5972 13.8157 13.5972 11.8582C13.5972 9.90059 15.4025 8.21637 17.7567 8.21637C20.1109 8.21637 21.9162 9.90059 21.9162 11.8582Z"
              stroke="#E8AA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.537 9.66223C15.537 9.66223 14.4653 11.2299 14.4653 12.3061C14.4653 13.3823 15.748 14.735 17.7661 14.735C19.7347 14.735 21.1496 13.6898 21.1924 12.3061C21.2352 10.9224 20.1334 9.93741 20.1334 9.93741C20.1334 9.93741 20.7569 11.9295 20.4452 12.7367C20.1334 13.544 19.1242 14.5206 17.7661 14.3963C16.4081 14.272 15.1193 12.7861 15.1193 12.3061C15.1193 11.8261 15.537 9.66223 15.537 9.66223Z"
              fill="#1E601B"
            />
            <path d="M15.9307 12.3283H19.5389" stroke="#188396" />
            <path d="M16.2661 11.8059H19.3706" stroke="#E8AA00" />
            <path
              d="M19.2338 12.4112H16.365L17.8125 10.2763L19.2338 12.4112Z"
              stroke="#E8AA00"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123991">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ElSalvador;
